// Utils
import { examServiceUrl } from "src/utils/services/servicesHelper";

// Types
import { StreamAddress } from "./types";

const socketBase = () =>
  examServiceUrl.replace(/^http/, "ws").replace(/\/+$/, "");

const watchUrl = ({ clinicId, deviceId }: StreamAddress): string =>
  `${socketBase()}/clinics/${clinicId}/devices/${deviceId}/live-view/watch`;

export { watchUrl };
